export const BASE_URL =
  process.env.REACT_APP_BASE_URL || "http://localhost:8080";
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID || "myclientid";
export const CLIENT_SECRET =
  process.env.REACT_APP_CLIENT_SECRET || "myclientsecret";
export const TOKEN_KEY = "com.esibape/token";
